import i from"graphql-tag";import{CircleTopicFragmentDoc as y,CircleTopicBaseFragmentDoc as r,CircleRsvpQuestionFragmentDoc as n,CircleFacilitatorFragmentDoc as s,CircleTopicSessionFragmentDoc as u,CircleTopicAuthenticatedFragmentDoc as g,CircleTopicRsvpFragmentDoc as m,CircleRsvpBaseFragmentDoc as C}from"./fragments.generated.es.js";import*as t from"@apollo/react-hooks";const c={},p=i`
    query fetchTopic($topicSlug: String!) {
  circleTopicBySlug(slug: $topicSlug) {
    id
    ...CircleTopic
  }
}
    ${y}
${r}
${n}
${s}
${u}`;function F(e){const o={...c,...e};return t.useQuery(p,o)}function d(e){const o={...c,...e};return t.useLazyQuery(p,o)}const a=i`
    query fetchTopicWithRsvps($topicSlug: String!) {
  circleTopicBySlug(slug: $topicSlug) {
    id
    ...CircleTopicAuthenticated
  }
}
    ${g}
${r}
${n}
${s}
${m}
${C}
${u}`;function h(e){const o={...c,...e};return t.useQuery(a,o)}function Q(e){const o={...c,...e};return t.useLazyQuery(a,o)}const l=i`
    query getCalendarLinks($rsvpId: ID!) {
  circleCalendarLinksByRsvp(rsvpId: $rsvpId) {
    __typename
    ... on CircleCalendarLinks {
      google
      outlook
      ics
    }
    ... on CircleNotFoundError {
      message
    }
  }
}
    `;function f(e){const o={...c,...e};return t.useQuery(l,o)}function D(e){const o={...c,...e};return t.useLazyQuery(l,o)}export{p as FetchTopicDocument,a as FetchTopicWithRsvpsDocument,l as GetCalendarLinksDocument,d as useFetchTopicLazyQuery,F as useFetchTopicQuery,Q as useFetchTopicWithRsvpsLazyQuery,h as useFetchTopicWithRsvpsQuery,D as useGetCalendarLinksLazyQuery,f as useGetCalendarLinksQuery};
//# sourceMappingURL=topic.generated.es.js.map
